import styled from "@xstyled/styled-components";

export const PageWrapper = styled.section`
  height: calc(100vh - 48px);
  width: 100%;
`;
